import { Info } from "@mui/icons-material";
import styled from "styled-components";
import { useState } from "react";
import { Add, Remove } from "@mui/icons-material";
import Multibuy from "./Multibuy";
import { useDispatch, useSelector } from "react-redux";
import { cartActions } from "../store/cart-slice";
import { useNavigation } from "../utils/navigation";
import { useContext } from "react";
import { ProductContext } from "../context/ProductContext";
import { useTranslation } from "react-i18next";

const Container = styled.div`
  width: 20vw;
  display: flex;
  flex-direction: column;
  margin: 3px;
  padding: 0;
  //height:90vh;
  @media only screen and (max-width: 768px) {
    //height:70vh;
    margin: 0;
    padding: 0;
    min-width: 100vw;
    margin-bottom: 40px;
  }
`;
const Top = styled.div`
  display: flex;
  flex-direction: column;
  height: 200px;
  padding: 10px;
  cursor: pointer;
  @media only screen and (max-width: 768px) {
    padding: 0px;
    height: 180px;
  }
`;
const Image = styled.img`
  height: 100%;
  object-fit: contain;
  display: block;
  margin: 0 auto;
  width: auto;
  max-width: 200px;
  @media only screen and (max-width: 768px) {
    max-width: 180px;
  }
`;
const Review = styled.div`
  min-width: 80px;
  position: absolute;
  font-size: 10px;
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
  color: #fff;
  padding: 5px 5px;
  z-index: 3;
  background: teal;
  margin-left: 10px;
  margin-top: 5px;
  @media only screen and (max-width: 768px) {
    font-size: 12px;
    margin-top: 5px;
    margin-left: 5px;
  }
`;

const Bottom = styled.div`
  flex: 1;
  color: #041e42;
  padding: 20px;
  @media only screen and (max-width: 768px) {
  }
`;

const MultibuyContainer = styled.div``;
const ProductTitle = styled.h2`
  font-size: 20px;
  line-height: 1.25;
  font-weight: 100;
  font-family: "Righteous";
  white-space: nowrap;
  cursor: pointer;
  @media only screen and (max-width: 768px) {
    font-size: 16px;
  }
`;
const ProductPrice = styled.h2`
  font-size: 20px;
  @media only screen and (max-width: 768px) {
    font-size: 15px;
    font-weight: 700;
  }
`;
const NicotineTitle = styled.h2`
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  padding: 5px;
  margin-top: 15px;
  @media only screen and (max-width: 768px) {
    font-size: 12px;
    font-weight: bold;
  }
`;
const Nicotine = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: ${(props) => (props.available ? "teal" : "#ccc")};
  padding: 4px;
  align-items: center;
  height: 30px;
  @media only screen and (max-width: 768px) {
    margin-left: 0px;
  }
  ${(props) =>
    !props.available &&
    `
    position: relative; /* dodano svojstvo za pozicioniranje pseudoelementa */
    
    :before {
        content: ''; /* stvara pseudo-element */
        position: absolute;
        top: 50%;
        left: 0; 
        width: 100%; 
        border-top: 1px solid #696969; 
        height:1px;
        transform: rotate(-3deg); 
    }
    `}
`;
const NicotineMG = styled.h2`
  color: white;
  font-weight: 700;
  font-size: 15px;
  margin-left: 10px;
`;
const Circles = styled.div`
  display: flex;
  justify-content: space-around;
`;
const Circle = styled.div`
  flex: 1;

  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #9dfafa;
  margin: 0px 2px;
  border: 0.5px solid white;
`;

const AddContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
  margin-bottom: 20px;
  margin-left: 10px;
  margin-right: 10px;

  gap: 10px;
  flex-direction: column;
  @media only screen and (max-width: 768px) {
    flex-direction: row;
  }
`;
const AmountContainer = styled.div`
  border: 2px solid #5862bf;
  padding: 5px;
  border-radius: 100px;
  display: flex;
  align-items: center;
  font-weight: 700;
  margin-left: 10px;
  width: 100%;
  justify-content: space-around;
  align-items: center;
  @media only screen and (max-width: 768px) {
    max-width: 45%;
    height: 35px;
    padding: 3px;
  }
`;

const AmountInput = styled.input`
  border: none;
  box-sizing: border-box;
  height: 100%;
  border: none;
  outline: none;
  max-width: 40px;
  background: none;
  font-weight: 600;
  font-size: 16px;
  ::placeholder {
    font-size: 12px;
    font-weight: 100;
    color: #ececec;
  }
  text-align: center;
`;
const Button = styled.button`
  padding: 12px;
  border: 2px solid #5862bf;
  border-radius: 100px;
  background-color: #5862bf;
  cursor: pointer;
  font-weight: 500;
  color: white;
  width: 100%;
  white-space: nowrap;
  &:hover {
    background-color: white;
    color: #5862bf;
  }
  font-size: 12px;
  @media only screen and (max-width: 768px) {
    width: 50%;
  }
`;

const NotAvailable = styled.div`
  min-height: 80px;
  border: 0.1px solid teal;
  background-color: #e7e7e771;
  border-radius: 10px;
  margin-top: 80px;
  padding: 0px 5px;
  margin-bottom: 20px;
  @media only screen and (max-width: 768px) {
    margin-top: 10px;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
  }
`;
const NotAvailableTitle = styled.h2`
  font-size: 20px;
  font-weight: 100;
  white-space: nowrap;
  font-family: "Righteous";
  margin: 0px;
  padding: 0px;
  padding-left: 20px;
  @media only screen and (max-width: 768px) {
    font-size: 16px;
  }
`;
const NotAvailableText = styled.h6`
  display: inline;
  font-size: 14px;
  font-weight: 400;
  margin: 0px;
  padding: 0px;
  @media only screen and (max-width: 768px) {
    font-size: 14px;
  }
`;
const ProductCard = ({ item }) => {
  const { t, i18n } = useTranslation();

  const [isHidden, setIsHidden] = useState(false);
  const [amount, setAmount] = useState(1);
  const { goToProduct } = useNavigation();
  const { setPopUp } = useContext(ProductContext);

  const getColor = (nicotine, val) => {
    const nicotineValue = parseInt(nicotine);
    return nicotineValue > val ? "white" : "teal";
  };

  function handleChange(e) {
    const value = parseInt(e.target.value);
    const newValue = Math.max(value, 0);
    setAmount(newValue);
  }
  function addOne() {
    if (parseInt(amount) >= 0) {
      setAmount(parseInt(amount) + 1);
    } else {
      setAmount(1);
    }
  }
  function removeOne() {
    if (parseInt(amount) > 0) {
      setAmount(parseInt(amount) - 1);
    }
  }

  const dispatch = useDispatch();
  const images = item.images.map((img) => img.image_url); // izvlačenje svih URL-ova slika u niz
  const primaryImage = images.find(
    (img) => item.images.find((i) => i.is_primary_image).image_url === img
  ); // pronalaženje URL-a primarne slike

  const addToCart = (quantity) => {
    dispatch(
      cartActions.addToCart({
        article: item,
        quantity: quantity,
      })
    );
    setAmount(0);
  };

  return (
    <Container>
      <Top
        onClick={() =>
          goToProduct(
            item.category.toLowerCase(),
            item.title.toLowerCase().replace(/ /g, "-")
          )
        }
      >
        {item.review != null ? (
          i18n.language === "en" ? (
            <></>
          ) : (
            <Review>{item.review}</Review>
          )
        ) : (
          <></>
        )}

        <Image src={primaryImage} alt={item.title}></Image>
      </Top>
      <Bottom>
        {item.state === "Dostupno" ? (
          <MultibuyContainer>
            <Multibuy />
          </MultibuyContainer>
        ) : (
          <MultibuyContainer>
            <Button
              onClick={() => setPopUp(item)}
              style={{
                minWidth: "100%",
                textTransform: "uppercase",
                borderRadius: "5px",
              }}
            >
              {t("ProductCard.SUBSCRIBE_TEXT")}
            </Button>
          </MultibuyContainer>
        )}
        <ProductTitle
          onClick={() =>
            goToProduct(
              item.category.toLowerCase(),
              item.title.toLowerCase().replace(/ /g, "-")
            )
          }
        >
          {item.category} {item.title}
        </ProductTitle>
        <ProductPrice>{item.price}RSD</ProductPrice>
        <NicotineTitle>{t("ProductCard.NICOTINE_STRENGTH")}</NicotineTitle>
        <Nicotine available={item.state === "Dostupno" ? true : false}>
          <NicotineMG>{item.nicotine}MG</NicotineMG>
          <Circles>
            <Circle style={{ backgroundColor: getColor(item.nicotine, 0) }} />
            <Circle style={{ backgroundColor: getColor(item.nicotine, 5) }} />
            <Circle style={{ backgroundColor: getColor(item.nicotine, 13) }} />
            <Circle style={{ backgroundColor: getColor(item.nicotine, 20) }} />
            <Circle style={{ backgroundColor: getColor(item.nicotine, 30) }} />
          </Circles>
        </Nicotine>
        {item.state === "Dostupno" ? (
          <AddContainer>
            <AmountContainer>
              <Remove onClick={removeOne} />
              <AmountInput
                type="number"
                value={amount}
                step={1}
                min={0}
                onChange={handleChange}
                aria-label="quantity"
              />
              <Add onClick={addOne} />
            </AmountContainer>

            <Button onClick={() => addToCart(amount)}>
              {t("ProductCard.ADD_TO_CART_BUTTON")}
            </Button>
          </AddContainer>
        ) : (
          <NotAvailable>
            <NotAvailableTitle>
              {" "}
              {i18n.language === "sr" ? item.state : "Out Of Stock"}
            </NotAvailableTitle>
            <NotAvailableText>
              {t("ProductCard.APOLOGIZE")}{" "}
              <span style={{ fontWeight: "700" }}>
                {item.category} {item.title} {item.nicotine}MG
              </span>{" "}
              {t("ProductCard.NOT_AVAILABLE_TEXT")}
            </NotAvailableText>
          </NotAvailable>
        )}
      </Bottom>
    </Container>
  );
};

export default ProductCard;
